import axios, { Method, AxiosRequestConfig, AxiosPromise, AxiosError, AxiosResponse } from 'axios';
import * as querystring from 'querystring';
import { settings } from './__settings';
import FormData from 'form-data';

export abstract class HTTPRequest {

    public constructor( path: string | null = null, url: string | null = null ) {
        if ( url ) this.url = url;
        if ( path ) this.path = path;
    }

    public url: string = settings.URL.api;
    public path: string = '';

    public params: Record<string, any> = {};
    public body: any = {};
    public formData: FormData = new FormData();
    public useformData: boolean = false;
    public formEncoded: any = {};
    public headers: any = {};

    public timeOut: number = 30000;


    public response: AxiosResponse;
    public error: boolean = false;
    public errorMessage: string = '';
    public data: any = {};

    public async get(): Promise<boolean> { return await this.execute( 'GET' ); }
    public async put(): Promise<boolean> { return await this.execute( 'PUT' ); }
    public async post(): Promise<boolean> { return await this.execute( 'POST' ); }
    public async delete(): Promise<boolean> { return await this.execute( 'DELETE' ); }

    protected abstract async preExecute(): Promise<boolean>;

    protected async execute( method: Method ): Promise<boolean> {

        try {

            if ( await this.preExecute() == false )
                throw new Error( 'Error in pre-execution method' );

            this.response = await axios( this.getConfig( method ) );
            this.data = this.response.data;
            return true;
        } catch ( e ) {

            this.error = String( e ).includes( 'code 404' ) ? false : true;
            this.errorMessage = e;

            if ( !String( e ).includes( 'code 404' ) )
                console.log( e );
        }
        return false;
    }

    protected getConfig( method: Method ): AxiosRequestConfig {

        let config: AxiosRequestConfig = {};
        config.baseURL = this.url + this.path;
        config.timeout = this.timeOut;
        config.method = method;
        config.withCredentials = true;
        if ( Object.keys( this.params ).hasRows() )
            config.params = this.params;

        if ( Object.keys( this.body ).hasRows() ) {
            config.data = this.body;
            this.headers['Content-Type'] = 'application/json';
        }

        else if ( Object.keys( this.formEncoded ).hasRows() ) {
            config.data = querystring.stringify( this.formEncoded );
            this.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }

        else if ( this.useformData ) {
            config.data = this.formData;
            this.headers['Content-Type'] = 'multipart/form-data';
        }

        if ( this.headers ) {
            config.headers = this.headers;
        }
        return config;
    }
}

export class apiRequest extends HTTPRequest {

    public constructor( path: string | null = null, url: string | null = null ) {
        super( path, url );
        //this.headers['Access-Control-Allow-Origin'] = '*';
    }

    protected async preExecute(): Promise<boolean> {
        return true;
    }
}